<template>
<div class="page home-page home-logistics">
	<navbar />
	<logistics-sidebar />
	<statistic-bar />
</div>
</template>

<script>
import Navbar from '@/components/main/Navbar'
import LogisticsSidebar from './components/LogisticsSidebar'
import StatisticBar from '@/components/main/StatisticBar'
import { runStatisticAnimation } from '@/utils/helpers'

export default {
	components: {
		Navbar,
		LogisticsSidebar,
		StatisticBar
	},
	mounted() {
		runStatisticAnimation()
	}
}
</script>

<style lang="scss">
.home-logistics {
	background-image: url('../../assets/images/back_4.jpg');
	position: absolute;
	z-index: 1;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-size: cover;

	.navbar {
		animation: fadeIn 2s linear 1s forwards;
	}
}
</style>
